export default class DrawOcr{
  canvas=null;
  ctx=null;
  dpr=1;
  width=0;
  height=0;
  f_img_w=0;
  f_img_h=0;
  constructor(el_id,image,_image){
    const that=this;

    // Canvas 对象
    that.canvas =document.getElementById(el_id)
    // 渲染上下文
    that.ctx = that.canvas.getContext('2d')

    that.width = image.width
    that.height = image.height

    // 初始化画布大小
    // that.dpr = wx.getWindowInfo().pixelRatio
    that.canvas.width = that.width * that.dpr
    that.canvas.height = that.height * that.dpr
    that.ctx.scale(that.dpr, that.dpr)

    // 矩形
    // that.ctx.fillStyle = '#FFFFFF'
    // that.ctx.fillRect(0, 0, that.canvas.width , that.canvas.height )

    that.f_img_w=_image.width;
    that.f_img_h=_image.height;

    // 图片
    that.ctx.drawImage(image,0, 0,that.width , that.height)
  }
  setPostion(points=[]){
    const that=this;
    points.map(pos=>{
      that.setPostionItem(pos);
    })
  }
  setPostionItem(points=[]){
    console.log(points)
    const that=this;
    let w_r=that.width/that.f_img_w;
    let h_r=that.height/that.f_img_h;
    console.log(that.width,that.height)
    console.log(w_r,h_r,that.dpr)
    // 遍历点数组，绘制线条
    that.ctx.beginPath();
    that.ctx.lineWidth=2
    that.ctx.strokeStyle='#FF0000';//设置描边颜色
    that.ctx.moveTo(points[0].x*w_r, points[0].y*h_r);
    for (let i = 1; i < points.length; i++) {
      that.ctx.lineTo(points[i].x*w_r, points[i].y*h_r);
    }
    // that.ctx.fill()
    that.ctx.closePath()
    that.ctx.stroke(); // 绘制线条
  }
  getImageFile(callback){
    // 生成图片
    wx.canvasToTempFilePath({
      canvas:this.canvas,
      success: res => {
        // 生成的图片临时文件路径
        typeof callback==="function"&&callback(res.tempImagePath)
        // that.setData({
        //   src: res.tempImagePath
        // })
      },
    })
  }
}



// WEBPACK FOOTER //
// ./src/components/Admin/EnergyConsumption/common/DrawOcr.js